export function getByKey(key: string) {
    return (obj: { [key: string]: string }) => {
        return obj[key];
    };
}

/**
 *
 * Makes routes waiting for Path Vars.
 * "I DON'T Like what I did hear. Has to be a better way but my brain says neigh"
 *
 * @param pathVars
 * @returns
 */
export function urlTag(path: TemplateStringsArray, ...otherPaths: ((() => string) | string)[]) {
    return function url(obj: { [key: string]: string }) {
        const finalURL: string[] = [];

        for (let i = 0; i < Math.max(path.length, otherPaths.length); i++) {
            if (i < path.length) {
                finalURL.push(path[i]);
            }
            if (i < otherPaths.length) {
                const op = otherPaths[i];
                if (typeof op === 'string') {
                    const l = obj[op];
                    if (l) {
                        finalURL.push(l);
                    } else {
                        finalURL.push(op);
                    }
                } else if (typeof op === 'function') {
                    finalURL.push(op());
                }
            }
        }

        return finalURL.join('');
    };
}

/**
 * Attaches "dl" query param to url to trigger Content-Disposition: attachment
 * as configured by our special CloudFront distribution transformer function.
 *
 * @param url
 * @returns
 */
export function tryMakeDownloadUrl(url?: string) {
    if (url !== undefined)
        return url.includes('?') ? (url += '&dl=1') : (url += '?dl=1');
}